import { unselectableProperties } from '../../utils/helpers';

const makeFormElements = (output, config) => {
    const elements = [];
    if (!output || !config) {
        return [];
    }
    for (let [key, propertyConfig] of Object.entries(config.attributes)) {
        const value = output[key] || null;

        if (!value || (Array.isArray(value) && value.length === 0)) {
            continue;
        }

        let valueElement = null;
        let label = propertyConfig.label;

        switch (propertyConfig.sioType) {
            case 'reference':
                valueElement = {
                    type: 'reactReferenceDisplay',
                    attributes: {
                        'react-props': JSON.stringify({
                            reference: typeof value == "object" ? value : value?.filter(
                                (v) => v.id && v.id !== 'undefined'
                            ),
                        }),
                    },
                    ...unselectableProperties,
                };
                break;

            case 'translatable':
                valueElement =
                    value != null && typeof value === 'object'
                        ? value[Object.keys(value)?.[0]] ?? ''
                        : value;
                break;

            case 'collection':
                valueElement = `${value.length} ${
                    value.length === 1 ? 'Element' : 'Elemente'
                }`;
                break;

            case 'choice':
                valueElement = {
                    type: 'reactChoiceDisplay',
                    attributes: {
                        'react-props': JSON.stringify({
                            config: propertyConfig,
                            value: value,
                        }),
                    },
                    ...unselectableProperties,
                };
                break;

            case 'checkbox':
                label = propertyConfig.checkboxLabel;
                valueElement = {
                    type: 'div',
                    ...unselectableProperties,
                    content: value ? 'ja' : 'nein',
                };
                break;

            case 'filter-condition':
                valueElement = {
                    type: 'div',
                    ...unselectableProperties,
                    content: value ? 'Bedingung hinterlegt' : 'Keine Bedingung',
                };
                break;

            default:
                valueElement = valueElement = {
                    type: 'div',
                    ...unselectableProperties,
                    content: value,
                };
        }

        if (valueElement != null) {
            elements.push({
                ...unselectableProperties,
                components: [
                    {
                        tagName: 'div',
                        attributes: { class: 'flex gap-2' },
                        ...unselectableProperties,
                        components: [
                            {
                                tagName: 'strong',
                                content: label + ':',
                                ...unselectableProperties,
                            },
                            {
                                ...valueElement,
                                // ...unselectableProperties,
                            },
                        ],
                    },
                ],
            });
        }
    }

    return elements;
};

export const makeFormEditorComponents = (output, config) => {
    if (!output || !config) {
        return [
            {
                tagName: 'div',
                content: 'Bearbeiten Sie die Blockeigenschaften über dem Stift',
                ...unselectableProperties,
            },
        ];
    }
    const makeDynamicElements = makeFormElements(output, config);
    const elements =
        makeDynamicElements?.length > 0
            ? makeDynamicElements
            : [{
                  tagName: 'div',
                  content:
                      'Bearbeiten Sie die Blockeigenschaften über dem Stift',
                  ...unselectableProperties,
              }];

    return [
        {
            tagName: 'div',
            attributes: {
                class: output?.panelClassName ?? 'panel panel-default',
            },
            ...unselectableProperties,
            components: [
                [
                    {
                        tagName: 'h4',
                        attributes: {
                            class: 'font-medium text-xl mb-4',
                        },
                        content: config.title,
                        ...unselectableProperties,
                    },
                    {
                        tagName: 'div',
                        attributes: { class: 'mb-4' },
                        ...unselectableProperties,
                        components: config.description
                            ? [
                                  {
                                      tagName: 'p',
                                      content: config.description,
                                      ...unselectableProperties,
                                  },
                              ]
                            : '',
                    },
                    ...elements,
                ],
            ],
        },
    ];
};
